import { useMe as useAuthContextMe } from '@crehana/web/dist/ReactContexts/AuthContext';

/**
 * Plase use `import { useMe } from '@crehana/web/dist/ReactContexts/AuthContext';`
 * @deprecated
 */
export const useMe = useAuthContextMe;

export default useMe;
